/**
 * Multi-column mobile switcher — shows 2 dropdowns on mobile
 * so users can pick which 2 columns to compare side by side.
 */
class MultiColumnSwitcher extends HTMLElement {
  connectedCallback() {
    this.carousel = this.closest('.section-stack')?.querySelector('scroll-carousel');
    if (!this.carousel) return;

    this.columns = Array.from(this.carousel.querySelectorAll('.multi-column__item'));
    if (this.columns.length < 2) return;

    this.selectLeft = this.querySelector('[data-switcher="left"]');
    this.selectRight = this.querySelector('[data-switcher="right"]');
    if (!this.selectLeft || !this.selectRight) return;

    this.buildOptions();
    this.selectLeft.value = '0';
    this.selectRight.value = '1';

    this.selectLeft.addEventListener('change', () => this.onSelectionChange());
    this.selectRight.addEventListener('change', () => this.onSelectionChange());

    this.onSelectionChange();
  }

  buildOptions() {
    this.columnNames = this.columns.map((col, i) => {
      return col.getAttribute('data-label') || `Column ${i + 1}`;
    });

    [this.selectLeft, this.selectRight].forEach((select) => {
      this.columnNames.forEach((name, i) => {
        const option = document.createElement('option');
        option.value = String(i);
        option.textContent = name;
        select.appendChild(option);
      });
    });
  }

  onSelectionChange() {
    const leftIndex = parseInt(this.selectLeft.value, 10);
    const rightIndex = parseInt(this.selectRight.value, 10);

    // Disable already-selected option in the other dropdown
    Array.from(this.selectLeft.options).forEach((opt) => {
      opt.disabled = parseInt(opt.value, 10) === rightIndex;
    });
    Array.from(this.selectRight.options).forEach((opt) => {
      opt.disabled = parseInt(opt.value, 10) === leftIndex;
    });

    // Show/hide columns
    this.columns.forEach((col, i) => {
      if (i === leftIndex || i === rightIndex) {
        col.style.display = '';
        col.style.order = i === leftIndex ? '0' : '1';
      } else {
        col.style.display = 'none';
      }
    });
  }
}

if (!customElements.get('multi-column-switcher')) {
  customElements.define('multi-column-switcher', MultiColumnSwitcher);
}
